<template>
  <!-- Komponent selecta do wyboru sposobu grupowania danych (np. grupowanie po dacie, kategorii itp.) -->
  <div class="group-by">
    <!-- Nagłówek sekcji -->
    <h3 class="margin-0">{{ t('division-into').toUpperCase() }}</h3>
    <!-- Rozwijana lista z dostępnymi opcjami grupowania -->
    <select class="form-select"
            name="groupBy"
            v-model.lazy="value"
            :disabled="store.disabledFields?.division"
    >
      <!-- Każda opcja to inna metoda grupowania (np. po dacie, po użytkowniku itd.) -->
      <option
        v-for="(option, index) in store.groupBy"
        :key="index"
        :value="index"
      >
        {{ t(option) }}
      </option>
    </select>
  </div>
</template>

<script>
import { watch, ref } from "vue";

export default {
  // Oczekiwany store jako prop (przechowuje aktualne filtry)
  props: {
    store: { required: true },
  },
  name: "GroupByFilter",
  setup(props) {
    // Wartość wybranej opcji pobierana ze stanu filtrów (jeśli nie ustawiono, będzie undefined)
    const value = ref(props.store.filters.groupBy);

    // Funkcja zapisująca zmianę wyboru do store'a
    const saveValue = (text) => {
      props.store.addItem("groupBy", text);
    };

    // Nasłuchuj zmiany w select-cie i aktualizuj store
    watch(value, (newValue) => {
      saveValue(newValue); // Zapisuj do store przy każdej zmianie
    });

    // Udostępniamy value do template
    return { value };
  },
};
</script>

<style scoped>
.group-by {
  width: 50%;
  min-height: 140px;
  /* background: #f5f4f2 url("../../assets/a-filter-bg.png") repeat-x left top; */
}
.group-by h3 {
  /* margin: 0; */
  padding: 10px 15px 5px;
  width: 100%;
  border-right: 1px solid #e1e1df;
}
.group-by select {
  height: 30px;
  margin-top: 6px;
  font-size: 12px;
}
</style>
